export * from './stored-document.service';
